import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from '../../src/i18n';
import { TP } from '../../constants/consts';
import DropzoneInput from '../../components/DropzoneInput';
import FbCircularProgress from '../../components/FbCircularProgress';
import { colors } from '../../constants/styleConstants';
import ImageTag from '../../components/ImageTag';
import { joinMediaFormats } from '../../utils/editCommon';

const useStyles = makeStyles(theme => ({
  form: {
    margin: theme.spacing(2),
  },
  fieldsBox: {
    padding: theme.spacing(2),
    margin: 0,
  },
  imageBlock: {
    position: 'relative',
  },
  venueLogo: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  closeIcon: {
    position: 'absolute',
    top: 5,
    right: 5,
    cursor: 'pointer',
    backgroundColor: colors.white,
    borderRadius: '50%',
  },
  stagesInput: {
    maxWidth: '100%',
  },
}));

const LogoUploadSection = ({ setLogo, src, formats }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [logoSrc, setLogoSrc] = useState(src);

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => setLogoSrc(null);
  }, []);

  useEffect(() => {
    setLogoSrc(src);
  }, [src]);

  const uploadVenueImage = images => {
    const image = images[0];

    if (image) {
      setUploadingLogo(true);
      const fileReader = new FileReader();
      fileReader.readAsDataURL(image.file);
      fileReader.onload = e => {
        setLogo(image);
        setLogoSrc(e.target.result);
      };
      fileReader.onloadend = () => {
        setUploadingLogo(false);
      };
    }
  };
  return (
    <>
      {uploadingLogo ? (
        <FbCircularProgress />
      ) : (
        <>
          {logoSrc ? (
            <div className={classes.imageBlock}>
              <CloseIcon className={classes.closeIcon} onClick={() => setLogoSrc(null)} />
              <ImageTag className={classes.venueLogo} src={logoSrc} alt={t(`${TP}.m_PHOTO`)} />
            </div>
          ) : (
            <DropzoneInput
              type="image"
              accept={formats}
              onFileUpload={uploadVenueImage}
              className={classes.uploadDropzone}
              title={t(`${TP}.UPLOAD_VENUE_PHOTO`)}
              subtitle={t(`${TP}.FN_UPLOAD_FILE_FORMAT_TEMPLATE`, {
                format: joinMediaFormats(formats),
              })}
            />
          )}
        </>
      )}
    </>
  );
};

LogoUploadSection.propTypes = {
  setLogo: PropTypes.func.isRequired,
  formats: PropTypes.arrayOf(PropTypes.string),
};

export default LogoUploadSection;
